import ReportInfoBox from "./reportInfoBox";

export default ReportInfoBox;
